<template>
  <div class="searchResult">
    <h4 class="mb-1">Members ({{ totalMembers }})</h4>
    <!-- <div class="textInfo mb-3">Select member(s) to see their parameters</div> -->

    <div v-if="searchResults.length">
      <v-data-table
        class="searchResults"
        :headers="headers"
        :items="searchResults"
        v-model="selectedRows"
        :options.sync="options"
        :server-items-length="totalMembers"
        :totalItems="totalMembers"
        item-key="MembershipId"
        :loading="loading"
        loading-text="Loading members..."
        :single-select="true"
        :show-select="false"
        @update:options="loadData"
        @click:row="rowClick"
        @dblclick:row="rowSelect"
        @item-selected="selectRow"
        @toggle-select-all="tagAllMembers"
        dense
      >
        <!-- eslint-disable-next-line -->
        <template v-slot:header.data-table-select="{ on, props }">
          <v-simple-checkbox v-if="searchResults.length < taggAllLimit" v-bind="props" v-on="on" />
        </template>
        <template v-slot:[`item.Tagged`]="{ item }">
          <v-simple-checkbox v-model="item.Tagged" @input="tagItem(item)"></v-simple-checkbox>
        </template>
      </v-data-table>
    </div>

    <v-footer padless fixed outlined elevation="3" class="footerBtnContainer">
      <div class="btnContainer">
        <v-btn outlined color="primary" class="mr-4" @click="exportResults">Export Results</v-btn>

        <!--v-if="showTaggAllBtn"-->
        <v-btn
          outlined
          :disabled="advancedSearch.includeAllPlans"
          color="primary"
          class="mr-4"
          @click="onTagAll"
          >Tag All</v-btn
        >

        <!-- v-if="showChangeViewModeBtn" -->
        <v-btn outlined color="primary" class="mr-4" @click="changeViewMode">{{
          isTaggedMembersMode ? 'View all' : 'View tagged'
        }}</v-btn>

        <!-- v-if="showClearTaggedBtn" -->
        <v-btn outlined color="primary" class="mr-4" @click="onClearTagged">Clear Tagged</v-btn>

        <v-btn
          v-if="canDeleteSelected"
          outlined
          color="primary"
          class="mr-4"
          @click="onDeleteSelected"
          >Delete Selected</v-btn
        >

        <v-spacer></v-spacer>
        <v-menu
          v-if="memberMenuItems.length > 0"
          rounded="0"
          :close-on-content-click="false"
          top
          left
          offset-x
          offset-y
          class="goToMenu"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              :disabled="!isSelectedMembersExists"
              color="primary"
              class="goToBtn"
              depressed
            >
              Go to..
            </v-btn>
          </template>
          <v-list class="goToList">
            <div v-for="item in memberMenuItems" :key="item.title">
              <v-list-group v-if="item.items.length" no-action>
                <template v-slot:activator>
                  <v-list-item-title> {{ item.title }} </v-list-item-title>
                </template>
                <v-list-item
                  v-for="subItem in item.items"
                  :key="subItem.title"
                  :to="subItem.to"
                  link
                >
                  <v-list-item-title> {{ subItem.title }} </v-list-item-title>
                </v-list-item>
              </v-list-group>

              <v-list-item v-else :to="item.to" link>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </div>

            <!-- <v-list-item v-for="item in memberMenuItems" :key="item.title" :to="item.to" link>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item> -->
          </v-list>
        </v-menu>
      </div>
    </v-footer>
    <Dialog ref="confirmationDialog"></Dialog>
  </div>
</template>

<script>
import Utils from '@/utils.js';
import Dialog from '@/components/layout/Dialog.vue';

export default {
  name: 'SearchResult',

  components: {
    Dialog,
  },

  mounted: function () {
    this.getDeleteSelectedPermission();

    const fields = this.searchMemberFields;
    if (fields) {
      this.isTaggedMembersMode = false; // search
      this.getMembers(1);
    } else {
      const userInfo = this.$store.getters.userInfo;
      if (userInfo && userInfo.HasTaggedMembers) {
        this.isTaggedMembersMode = true;
        this.getTaggedMembers(1);
      }
    }
  },

  data() {
    return {
      loading: false,
      options: {
        page: 1,
        itemsPerPage: 15,
        sortBy: ['Surname'],
        sortDesc: [false],
      },
      headers: [
        { text: 'Tagged', value: 'Tagged', sortable: false },
        { text: 'NI Number', value: 'StateNo' },
        { text: 'Title', value: 'Title' },
        { text: 'Surname', value: 'Surname' },
        { text: 'Forename', value: 'Forename' },
        { text: 'Group', value: 'GroupName' },
        { text: 'Status', value: 'Status' },
        { text: 'EmployeeNo', value: 'EmployeeNo' },
        { text: 'Date of Birth', value: 'DateOfBirth' },
      ],
      selectedRows: [],
      totalMembers: 0,
      searchResults: [],
      membersLoaded: false,
      isTaggedMembersMode: false,
      taggAllLimit: 500,
      canDeleteSelected: false,
    };
  },
  methods: {
    rowClick(item, row) {
      row.select(true);
    },
    rowSelect(item, row) {
      console.log(item);
      console.log(row);
      this.selectRow(row);
      if (row.item.PlanId) {
        this.$store.commit('setCurrentPlan', row.item.PlanId);
      }
      this.goToDetails();
    },
    async exportResults() {
      try {
        this.loading = true;
        const fields = this.searchMemberFields;
        if (fields || this.isTaggedMembersMode) {
          let response = null;
          if (this.isTaggedMembersMode) {
            var params = {
              planId: this.currentPlanId,
              startRow: 0,
              maxRows: 99999,
              orderBy: this.options.sortBy[0] ? this.options.sortBy[0] : 'Surname',
              export: true,
            };

            response = await this.$api.post('member/GetTaggedMembers', params);
          } else if (fields) {
            const orderBy = this.options.sortBy[0] ? this.options.sortBy[0] : 'Surname';
            var data = {
              SearchFields: fields,
              startRow: 0,
              maxRows: 999999,
              orderBy: orderBy,
              ExportToFile: true,
              advancedSearch: this.advancedSearch.advancedSearch,
              advancedSearchItems: fields,
              includeAllPlans: this.advancedSearch.includeAllPlans,
            };
            let action = '/member/GetSearchResults';
            if (this.advancedSearch.advancedSearch) {
              action = '/member/GetAdvancedSearchResults';
            }

            response = await this.$api.post(action, data);
          }

          if (response) {
            const url = window.URL.createObjectURL(
              new Blob([response.data], {
                type: 'application/csv',
              })
            );
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'exportresults.csv');
            document.body.appendChild(link);
            link.click();
          }
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },

    async onDeleteSelected() {
      if (!this.canDeleteSelected) return;

      try {
        await this.$refs.confirmationDialog.open(
          'Warning',
          'This will delete all currently tagged members from the system. Please confirm that you wish to continue.'
        );
        this.deleteTaggedMembers();
      } catch (err) {
        console.log(err);
      }
    },

    async deleteTaggedMembers() {
      if (!this.canDeleteSelected) return;

      try {
        await this.$api.delete('/member/deleteselectedmembers');

        const message = {
          type: 'success',
          text: 'Delete was successful',
        };
        this.$store.commit('setSelectedMember', null);
        this.$store.commit('setNotificationMessage', message);
        this.loadData();
      } catch (err) {
        console.error(err);
      }
    },

    async getDeleteSelectedPermission() {
      this.canDeleteSelected = false;

      try {
        const response = await this.$api.get('/user/GetTaskPermission', {
          params: { planId: this.currentPlanId, taskName: 'Delete Selected' },
        });
        this.canDeleteSelected = response.data == 'Full';
      } catch (err) {
        console.error(err);
      }
    },

    tagItem(item) {
      if (item.Tagged) this.$store.commit('addTaggedMember', item);
      else this.$store.commit('removeTaggedMember', item);

      this.saveTagMember(item.MembershipId, item.Tagged);
    },

    selectRow(options) {
      this.$store.commit('setSelectedMember', options.item);
    },

    loadData() {
      if (!this.loading) {
        if (this.isTaggedMembersMode) this.getTaggedMembers();
        else this.getMembers();
      }
    },

    changeViewMode() {
      this.isTaggedMembersMode = !this.isTaggedMembersMode;
      if (this.isTaggedMembersMode) {
        this.getTaggedMembers(1);
      } else {
        this.getMembers(1);
      }
    },

    goToDetails() {
      this.$router.push({ name: 'BasicData', path: '/MemberDetails' });
    },

    async getMembers() {
      const fields = this.searchMemberFields;
      if (fields) {
        if (this.options.itemsPerPage < 0) {
          this.options.itemsPerPage = 15;
        }

        const startFromRow = 1 + (this.options.page - 1) * this.options.itemsPerPage;
        console.log(this.options.sortBy);
        var sortBy = this.options.sortBy[0] ? this.options.sortBy[0] : 'Surname';
        var isDesc = this.options.sortDesc[0];
        var orderBy = sortBy;
        if (isDesc) orderBy = orderBy + ' desc';

        var data = {
          SearchFields: fields,
          startRow: startFromRow,
          maxRows: this.options.itemsPerPage,
          orderBy: orderBy,
          advancedSearch: this.advancedSearch.advancedSearch,
          advancedSearchItems: fields,
          includeAllPlans: this.advancedSearch.includeAllPlans,
        };
        try {
          this.loading = true;
          let action = '/member/GetSearchResults';
          if (this.advancedSearch.advancedSearch) {
            action = '/member/GetAdvancedSearchResults';
          }
          let response = await this.$api.post(action, data);
          const s = JSON.parse(response.data);
          this.totalMembers = 0;
          this.searchResults = [];
          const rows = s.Rows;
          this.totalMembers = s.TotalRows;
          if (rows != null) {
            const selectedRows = [];
            rows.forEach((element) => {
              const dateOfBirth = new Date(element.Dob);
              const member = {
                Tagged: element.Tagged ? true : false,
                MembershipId: element.MembershipId,
                StateNo: element.StateNo,
                Surname: element.Surname,
                Forename: element.Forename,
                EmployeeNo: element.EmployeeNo,
                GroupName: element.GroupName,
                Title: element.Title,
                Status: element.Description,
                DateOfBirth: Utils.getDateStr(dateOfBirth),
                PlanId: element.PlanId,
              };
              this.searchResults.push(member);
              if (element.Tagged) {
                //this.$store.commit('addTaggedMember', member);
              }
              if (this.selectedMember && this.selectedMember.MembershipId == member.MembershipId) {
                selectedRows.push(member);
              }
            });

            this.getAllTaggedMembers();

            this.selectedRows = selectedRows;
            //this.options.sortBy=[sortBy];
            //this.options.sortDesc[0]=isDesc;
          }
          this.loading = false;
          console.log('loaded');
        } catch (err) {
          console.error(err);
        }
      }
    },

    async getTaggedMembers() {
      const startFromRow = 1 + (this.options.page - 1) * this.options.itemsPerPage;
      var sortBy = this.options.sortBy[0] ? this.options.sortBy[0] : 'Surname';
      var isDesc = this.options.sortDesc[0];
      var orderBy = sortBy;
      if (isDesc) orderBy = orderBy + ' desc';

      var params = {
        planId: this.currentPlanId,
        startRow: startFromRow,
        maxRows: this.options.itemsPerPage,
        orderBy: orderBy,
        export: false,
      };
      try {
        this.loading = true;
        let response = await this.$api.post('member/GetTaggedMembers', params);
        var s = JSON.parse(response.data);
        this.totalMembers = 0;
        this.searchResults = [];
        var rows = s.Rows;
        this.totalMembers = s.TotalRows;
        if (rows != null) {
          rows.forEach((element) => {
            const dateOfBirth = new Date(element.Dob);
            const member = {
              Tagged: true,
              MembershipId: element.MembershipId,
              StateNo: element.StateNo,
              Surname: element.Surname,
              Forename: element.Forename,
              EmployeeNo: element.EmployeeNo,
              GroupName: element.GroupName,
              Title: element.Title,
              Status: element.Description,
              DateOfBirth: Utils.getDateStr(dateOfBirth),
            };
            this.searchResults.push(member);

            //this.$store.commit('addTaggedMember', member.MembershipId);
            
          });

          this.getAllTaggedMembers();

          //this.$store.commit('setTaggedMembers', this.searchResults);
        }
        this.loading = false;
      } catch (err) {
        console.error(err);
      }
    },

    async saveTagMember(memberId, tagged) {
      const params = {
        memberId: memberId,
        planId: this.currentPlanId,
        tagged: tagged,
      };

      await this.$api.post(
        'member/tagmember?memberId=' +
          memberId +
          '&planId=' +
          this.currentPlanId +
          '&tagged=' +
          tagged,
        params
      );
    },

    async getAllTaggedMembers(){
      const response = await this.$api.get("member/GetAllTaggedMembers");
      let data = response.data;
      data.forEach((row) => {
        this.$store.commit('addTaggedMember', row);
      });
    },

    async tagAllMembers(options) {
      if (options.value) {
        const fields = this.searchMemberFields;
        if (fields) {
          const response = await this.$api.post('member/TagAll', fields);
          this.$store.commit('setTaggedMembers', this.searchResults);
          console.log(response.data);
          this.searchResults.forEach((r) => (r.Tagged = true));
        }
      } else {
        this.onClearTagged();
      }
    },

    async onTagAll() {
      let fields = this.searchMemberFields;
      if (fields) {
        if (this.advancedSearch.advancedSearch) {
          fields = {};
          fields['PlanId'] = this.currentPlanId;
          const response = await this.$api.post('member/TagAll', fields);
          this.$store.commit('setTaggedMembers', response.data);
          this.searchResults.forEach((r) => (r.Tagged = true));
        } else {
          const response = await this.$api.post('member/TagAll', fields);
          this.$store.commit('setTaggedMembers', response.data);
          this.searchResults.forEach((r) => (r.Tagged = true));
        }
      }
    },

    async onClearTagged() {
      const response = await this.$api.get('member/ClearTaggedMembers');
      this.$store.commit('setTaggedMembers', []);
      this.$store.commit('clearTaggedMembers');
      this.isTaggedMembersMode = false;
      this.searchResults.forEach((r) => (r.Tagged = false));
      this.getMembers(1);
      console.log(response);
    },
  },

  computed: {
    currentPlanId() {
      return this.$store.getters.currentPlanId;
    },
    selectedMember() {
      const selectedMember = this.$store.getters.selectedMember;
      if (selectedMember) return selectedMember;

      return null;
    },
    isSelectedMembersExists() {
      const selectedMember = this.$store.getters.selectedMember;
      if (selectedMember) return true;

      return false;
    },
    isTaggedMembersExists() {
      const taggedMembers = this.$store.getters.taggedMembers;
      if (taggedMembers && taggedMembers.length > 0) return true;

      return false;
    },
    showChangeViewModeBtn() {
      return this.showClearTaggedBtn || this.isTaggedMembersMode ? true : false;
    },
    showTaggAllBtn() {
      return (
        !this.isTaggedMembersMode && this.searchResults && this.totalMembers < this.taggAllLimit
      );
    },
    showClearTaggedBtn() {
      return this.$store.getters.userInfo && this.$store.getters.userInfo.HasTaggedMembers;
    },
    searchMemberFields() {
      return this.$store.state.searchMemberFields;
    },
    advancedSearch() {
      return this.$store.getters.advancedSearch;
    },
    memberMenuItems() {
      const menu = this.$store.getters.menu;
      if (menu && menu.length > 0) {
        const memberMenu = menu.find((x) => {
          return x.title == 'Members';
        });
        if (memberMenu) {
          const result = memberMenu.items.filter((x) => {
            return x.title != 'Search';
          });
          return result;
        }
      }

      return [];
    },
  },
  watch: {
    searchMemberFields() {
      const fields = this.searchMemberFields;
      if (fields) {
        this.isTaggedMembersMode = false; // search
        this.getMembers(1);
      } else {
        const userInfo = this.$store.getters.userInfo;
        if (userInfo && userInfo.HasTaggedMembers) {
          this.isTaggedMembersMode = true;
          this.getTaggedMembers(1);
        }
      }
    },
    currentPlanId: function () {
      this.totalMembers = 0;
      this.searchResults = [];
      this.getDeleteSelectedPermission();
    },
  },
};
</script>

<style lang="scss" scoped>
.searchResult {
  padding: 20px;
  margin-bottom: 10px;
}

.footerBtnContainer {
  .btnContainer {
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 12px;
    margin-top: 12px;
    width: 100%;
    display: flex;
  }
}
</style>

<style scoped>
.theme--light.v-data-table tbody tr.v-data-table__selected {
  background: #4a1cd41f !important;
}

.theme--light.v-data-table tbody tr {
  cursor: pointer;
}

.v-footer {
  padding: 0px;
}

.v-menu__content {
  position: fixed;
  bottom: 24px;
  right: 12px;
  top: unset !important;
  left: unset !important;
}
</style>
